import React, { useLayoutEffect, useState } from 'react'
import { formatDate } from 'shared/service/helpers/DateUtilities'

interface IProps {
  date?: Date
  onDateChanged?: (e: Date) => void
  readonly?: boolean
  disabled?: boolean
  className?: string
}

export default (props: IProps) => {
  const [dateString, setDateString] = useState<string>('')

  useLayoutEffect(() => {
    setDateString(formatDate(props.date))
  }, [props.date])

  const tryUpdateDate = (e: string) => {
    const processed = processDateString(e)

    if (canUpdateDateString(processed.parts)) {
      setDateString(processed.e)
    } else {
      return
    }

    const update = canUpdateDate(processed.parts)
    if (update.success) {
      props.onDateChanged(update.date)
    }
  }

  const processDateString = (e: string): { e: string; parts: string[] } => {
    if (e.length >= dateString.length) {
      e = e.replace('--', '-')

      if (e.length === 1 && +e > 3) {
        e = `0${e}`
      }

      if (e.length === 2 && e[1] !== '-') {
        if (+e > 31) {
          e = `0${e[0]}-${e[1]}`
        } else {
          e += '-'
        }
      }

      const parts = e.split('-')
      if (parts.length === 2 && +parts[1] > 1) {
        if (parts[1].length === 1) {
          parts[1] = `0${parts[1]}`
        }
        e = `${parts.join('-')}-`
      }
      return { e: e, parts: parts }
    } else {
      return { e: e, parts: e.split('-') }
    }
  }

  const canUpdateDate = (parts: string[]): { success: boolean; date: Date } => {
    const result = {
      success: false,
      date: null,
    }

    if (isInvalid(parts)) {
      return result
    }

    const flipped = `${parts[2]}-${parts[1]}-${parts[0]}`

    if (isNaN(Date.parse(flipped))) {
      return result
    }

    result.date = new Date(flipped)
    result.success = result.date.getMonth() + 1 === +parts[1]

    return result
  }

  const canUpdateDateString = (parts: string[]): boolean => {
    return !parts.some(p => isNaN(+p)) && parts.length <= 3
  }

  const tryUpdateDateEnter = (e: string) => {
    if (e === 'Enter') {
      const today = new Date()
      const parts = dateString.split('-')

      if (parts.length === 2) {
        parts.push(`${today.getFullYear()}`)
        tryUpdateDate(parts.join('-'))
      } else if (parts.length === 3 && parts[2].length === 0) {
        parts[2] = `${today.getFullYear()}`
        tryUpdateDate(parts.join('-'))
      }
    }
  }

  const isInvalid = (parts: string[]): boolean => {
    return (
      parts.length !== 3 ||
      +parts[0] < 1 ||
      +parts[0] > 31 ||
      +parts[1] < 1 ||
      +parts[1] > 12 ||
      parts[2].length !== 4
    )
  }

  return (
    <input
      type='text'
      value={dateString}
      onChange={e => tryUpdateDate(e.target.value)}
      onKeyUp={e => tryUpdateDateEnter(e.key)}
      disabled={props.disabled}
      readOnly={props.readonly}
      className={props.className}
    />
  )
}
